import React, { useState, useRef } from "react";
import PropTypes from "prop-types";

import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";

import Api from "utils/Api";
import { useAuth } from "context/AuthContext";

import LISTA_CARGOS from "components/RH/inputs/cargos";
import CargoAutocomplete from "components/RH/inputs/inputCargo";
import InputDate from "components/RH/inputs/InputDate";

import MaskEnum from "utils/MaskEnum";
import MaskUtil from "utils/MaskUtil";
import { useNotification } from "context/NotificationContext";

import bancos from "data/bancos"; // Ajuste o caminho conforme necessário

const { TipoEscala } = MaskEnum;

// Lista de horários de trabalho sugeridos
const LISTA_HORARIOS = [
  "08:00 - 18:00",
  "09:00 - 19:00",
  "07:00 - 17:00",
  "12:00 - 22:00",
  "14:00 - 22:00",
  "06:00 - 14:00",
  "22:00 - 06:00",
];



const DadosAdmissionais = ({
  dados,
  setDados,
  funcoes,
  HandleDropdownChange,
  HandleChange,
  departamentos,
  escolaridades,
  regimes,
  jornadas,
  pcds,
  BoxBtns,
  isNewFuncionario,
  onNextTab,
  onPreviousTab,
  funcionarioId,
  onSave,
  onLaudoPcdChange // Nova prop para passar o arquivo para o pai
}) => {
  const [errors, setErrors] = useState({});
  const [laudoPcd, setLaudoPcd] = useState(null);
  const laudoPcdFileRef = useRef(null); // Ref para manter o arquivo File real
  const notify = useNotification();
  const auth = useAuth();

  const validarCampos = () => {
    const novosErrors = {};

    // Validar Função
    if (!dados.funcaoId) {
      novosErrors.funcaoId = "Função é obrigatória";
    }

    // Validar Cargo
    if (!dados.cargo || dados.cargo.trim() === "") {
      novosErrors.cargo = "Cargo é obrigatório";
    }

    // Validar Departamento
    if (!dados.departamentoId) {
      novosErrors.departamentoId = "Departamento é obrigatório";
    }

    // Validar Escolaridade
    if (!dados.escolaridadeId) {
      novosErrors.escolaridadeId = "Escolaridade é obrigatória";
    }

    // Validar Data de Admissão
    if (!dados.dataAdmissao || dados.dataAdmissao.trim() === "") {
      novosErrors.dataAdmissao = "Data de Admissão é obrigatória";
    }

    // Validar Agência
    if (!dados.agencia || dados.agencia.trim() === "") {
      novosErrors.agencia = "Agência é obrigatória";
    }

    // Validar Conta Corrente
    if (!dados.contaCorrente || dados.contaCorrente.trim() === "") {
      novosErrors.contaCorrente = "Conta Corrente é obrigatória";
    }

    // Validar Data do Exame Admissional
    if (!dados.dataAdmissaoExam || dados.dataAdmissaoExam.trim() === "") {
      novosErrors.dataAdmissaoExam = "Data do Exame Admissional é obrigatória";
    }

    // Validar Tamanho do Uniforme
    if (!dados.tamanhoUniforme || dados.tamanhoUniforme.trim() === "") {
      novosErrors.tamanhoUniforme = "Tamanho do Uniforme é obrigatório";
    }

    // Validar Salário
    if (!dados.salario || dados.salario.trim() === "") {
      novosErrors.salario = "Salário é obrigatório";
    }

    // Validar Regime de Contratação
    if (!dados.regimeContratacaoId) {
      novosErrors.regimeContratacaoId = "Regime de Contratação é obrigatório";
    }

    // Validar Jornada de Trabalho
    if (!dados.jornadaTrabalhoId) {
      novosErrors.jornadaTrabalhoId = "Jornada de Trabalho é obrigatória";
    }

         // Validar PCD apenas se for PCD
     if (dados.isPcd && !dados.pcdId) {
       novosErrors.pcdId = "PCD é obrigatório quando a pessoa é PCD";
     }

    // Validar Tipo Escala
    if (!dados.tipoEscala) {
      novosErrors.tipoEscala = "Tipo Escala é obrigatório";
    }

    // Validar campos de PCD se for PCD
    if (dados.isPcd) {
      // Só exige laudo se não tiver um já existente
      if (!laudoPcd && !dados.urlLaudoMedico) {
        novosErrors.laudoPcd = "Laudo médico é obrigatório para PCD";
      }
    }

    setErrors(novosErrors);
    return Object.keys(novosErrors).length === 0;
  };

  const handleFieldChange = (field, value) => {
    // Limpar erro do campo quando o usuário começar a digitar
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: undefined }));
    }
  };

     const handlePcdChange = (value) => {
     setDados(prev => ({ 
       ...prev, 
       isPcd: value,
       pcdId: value ? prev.pcdId : null, // Limpa o tipo de PCD se não for PCD
       temLaudoSelecionado: value ? prev.temLaudoSelecionado : false
     }));
     if (!value) {
       setLaudoPcd(null); // Limpa o laudo se não for PCD
       laudoPcdFileRef.current = null; // Limpa a referência do arquivo
     }
     handleFieldChange('isPcd', value);
   };

  const handleLaudoChange = (e) => {
    // Captura direta do input file (como você mostrou)
    const arquivo = e.target.files[0]; // ← Este é o File object binário
    
    if (!arquivo) return;
    
    // Validações do arquivo - apenas PDF
    const allowedTypes = ['application/pdf'];
    const allowedExtensions = ['.pdf'];
    const maxSize = 10485760; // 10MB em bytes
    
    // Verificar extensão
    const fileExtension = arquivo.name.toLowerCase().substring(arquivo.name.lastIndexOf('.'));
    if (!allowedExtensions.includes(fileExtension)) {
      notify({
        type: "error",
        message: "Formato de arquivo não permitido. Use apenas PDF."
      });
      return;
    }
    
    // Verificar tipo MIME
    if (!allowedTypes.includes(arquivo.type)) {
      notify({
        type: "error",
        message: "Tipo de arquivo não permitido. Use apenas PDF."
      });
      return;
    }
    
    // Verificar tamanho
    if (arquivo.size > maxSize) {
      notify({
        type: "error",
        message: "Arquivo muito grande. O tamanho máximo permitido é 10MB."
      });
      return;
    }
    
    console.log("🔧 Arquivo File object:", arquivo);
    console.log("🔧 Tipo:", typeof arquivo);
    console.log("🔧 É File?", arquivo instanceof File);
    console.log("🔧 Nome:", arquivo.name);
    console.log("🔧 Tamanho:", arquivo.size);
    
    // Seguir o padrão correto - estado simples separado
    setLaudoPcd(arquivo);
    laudoPcdFileRef.current = arquivo;
    
    // Não colocar o File no estado principal do React
    // Apenas marcar que tem arquivo selecionado para validação
    setDados(prev => ({ 
      ...prev, 
      temLaudoSelecionado: true,
      nomeArquivoSelecionado: arquivo.name 
    }));
    
    // Passa o arquivo File binário para o componente pai
    if (onLaudoPcdChange) {
      onLaudoPcdChange(arquivo); // ← Arquivo binário
    }
    
    handleFieldChange('laudoPcd', arquivo);
    
    // Limpar erro do campo quando arquivo válido for selecionado
    if (errors.laudoPcd) {
      setErrors(prev => ({ ...prev, laudoPcd: undefined }));
    }
    
    notify({
      type: "success",
      message: `Arquivo "${arquivo.name}" selecionado com sucesso.`
    });
  };

  const handleSave = () => {
    if (validarCampos()) {
      // Chama a função de salvamento do componente pai
      console.log("Salvando dados admissionais...");
      if (onSave) {
        // Simula um evento para o HandleSubmit
        const mockEvent = { preventDefault: () => {} };
        onSave(mockEvent);
      }
    } else {
      notify({
        type: "error",
        message: "Por favor, preencha todos os campos obrigatórios."
      });
    }
  };



  const handleDownloadLaudo = async () => {
    if (!funcionarioId) {
      notify({
        type: "error",
        message: "ID do funcionário não encontrado."
      });
      return;
    }

    try {
      const Requicicao = new Api();
      const response = await Requicicao.Get({
        endpoint: `/Funcionarios/${funcionarioId}/DownloadLaudoMedico`,
        config: {
          ...auth.GetHeaders(),
          responseType: "blob"
        }
      });

      // Para download direto de blob
      const blob = new Blob([response], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = dados.nomeArquivoLaudoMedico || 'laudo_medico.pdf';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      notify({
        type: "success",
        message: "Download do laudo médico iniciado."
      });
    } catch (error) {
      console.error("Erro ao baixar laudo médico:", error);
      notify({
        type: "error",
        message: `Erro ao baixar laudo médico: ${error.message || "Tente novamente."}`
      });
    }
  };

  const handleRemoveLaudo = async () => {
    if (!funcionarioId) {
      notify({
        type: "error",
        message: "ID do funcionário não encontrado."
      });
      return;
    }

    try {
      const Requicicao = new Api();
      const response = await Requicicao.Delete({
        endpoint: `/Funcionarios/${funcionarioId}/RemoverLaudoMedico`,
        config: auth.GetHeaders()
      });

      if (response.codigoEstadoHttp === 200) {
        notify({
          type: "success",
          message: "Laudo médico removido com sucesso."
        });
        
        // Limpa os dados do laudo
        setDados(prev => ({ 
          ...prev, 
          laudoPcd: null,
          urlLaudoMedico: null,
          nomeArquivoLaudoMedico: null
        }));
        setLaudoPcd(null);
      } else {
        throw new Error(response.mensagemAdicional || "Erro ao remover laudo médico");
      }
    } catch (error) {
      console.error("Erro ao remover laudo médico:", error);
      notify({
        type: "error",
        message: `Erro ao remover laudo médico: ${error.message || "Tente novamente."}`
      });
    }
  };

  const CustomBoxBtns = () => (
    <div className="d-flex justify-content-end">
      <Button
        type="button"
        className="btn btn-secondary me-4"
        onClick={onPreviousTab}
      >
        Anterior
      </Button>
      {isNewFuncionario ? (
        <Button
          type="button"
          label="Salvar"
          className="btn btn-primary"
          onClick={handleSave}
        />
      ) : (
                 <Button
           type="button"
           label="Atualizar"
           className="btn btn-primary"
           onClick={handleSave}
         />
      )}
    </div>
  );

  return (
    <div className="row g-3">
      <div className="col-md-4">
        <label htmlFor="funcaoId" className="form-label">
          Função <span className="text-danger">*</span>
        </label>
        <Dropdown
          id="funcaoId"
          value={dados.funcaoId}
          onChange={(e) => {
            HandleDropdownChange(e, "funcaoId");
            handleFieldChange('funcaoId', e.value);
          }}
          options={funcoes}
          placeholder="Selecione uma Função"
          className={`w-100 ${errors.funcaoId ? 'p-invalid' : ''}`}
        />
        {errors.funcaoId && (
          <small className="text-danger">{errors.funcaoId}</small>
        )}
      </div>
      <div className="col-md-4">
        <label htmlFor="cargo" className="form-label">
          Cargo <span className="text-danger">*</span>
        </label>
        <CargoAutocomplete
          value={dados.cargo}
          onChange={(valor) => {
            setDados((prev) => ({ ...prev, cargo: valor }));
            handleFieldChange('cargo', valor);
          }}
          options={LISTA_CARGOS}
          placeholder="Digite ou selecione o cargo"
          className={errors.cargo ? 'p-invalid' : ''}
        />
        {errors.cargo && (
          <small className="text-danger">{errors.cargo}</small>
        )}
      </div>
      <div className="col-md-4">
        <label htmlFor="departamentoId" className="form-label">
          Departamento <span className="text-danger">*</span>
        </label>
        <Dropdown
          id="departamentoId"
          value={dados.departamentoId}
          onChange={(e) => {
            HandleDropdownChange(e, "departamentoId");
            handleFieldChange('departamentoId', e.value);
          }}
          options={departamentos}
          placeholder="Selecione um Departamento"
          className={`w-100 ${errors.departamentoId ? 'p-invalid' : ''}`}
        />
        {errors.departamentoId && (
          <small className="text-danger">{errors.departamentoId}</small>
        )}
      </div>
      <div className="col-md-4">
        <label htmlFor="escolaridadeId" className="form-label">
          Escolaridade <span className="text-danger">*</span>
        </label>
        <Dropdown
          id="escolaridadeId"
          value={dados.escolaridadeId}
          onChange={(e) => {
            HandleDropdownChange(e, "escolaridadeId");
            handleFieldChange('escolaridadeId', e.value);
          }}
          options={escolaridades}
          placeholder="Selecione uma Escolaridade"
          className={`w-100 ${errors.escolaridadeId ? 'p-invalid' : ''}`}
        />
        {errors.escolaridadeId && (
          <small className="text-danger">{errors.escolaridadeId}</small>
        )}
      </div>
      <div className="col-md-4">
        <label htmlFor="dataAdmissao" className="form-label">
          Data de Admissão <span className="text-danger">*</span>
        </label>
        <InputDate
          id="dataAdmissao"
          name="dataAdmissao"
          value={dados.dataAdmissao}
          onChange={(dateString) => {
            setDados((prev) => ({ ...prev, dataAdmissao: dateString }));
            handleFieldChange('dataAdmissao', dateString);
          }}
          placeholder="dd/mm/aaaa"
          className={`w-100 ${errors.dataAdmissao ? 'p-invalid' : ''}`}
        />
        {errors.dataAdmissao && (
          <small className="text-danger">{errors.dataAdmissao}</small>
        )}
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label htmlFor="banco" className="form-label">
            Banco
          </label>
          <Dropdown
            value={dados.banco}
            options={bancos}
            onChange={(e) => HandleDropdownChange(e, "banco")}
            optionLabel="nome" // Mostra o nome do banco no dropdown
            optionValue="codigo" // Usa o código do banco como valor
            placeholder="Selecione um banco"
            className="select"
            id="banco"
            name="banco"
          />
        </div>
      </div>
      <div className="col-md-4">
        <label htmlFor="agencia" className="form-label">
          Agência <span className="text-danger">*</span>
        </label>
        <InputText
          id="agencia"
          name="agencia"
          value={dados.agencia}
          onChange={(e) => {
            HandleChange(e);
            handleFieldChange('agencia', e.target.value);
          }}
          className={`form-control ${errors.agencia ? 'p-invalid' : ''}`}
        />
        {errors.agencia && (
          <small className="text-danger">{errors.agencia}</small>
        )}
      </div>
      <div className="col-md-4">
        <label htmlFor="contaCorrente" className="form-label">
          Conta Corrente <span className="text-danger">*</span>
        </label>
        <InputText
          id="contaCorrente"
          name="contaCorrente"
          value={dados.contaCorrente}
          onChange={(e) => {
            HandleChange(e);
            handleFieldChange('contaCorrente', e.target.value);
          }}
          className={`form-control ${errors.contaCorrente ? 'p-invalid' : ''}`}
        />
        {errors.contaCorrente && (
          <small className="text-danger">{errors.contaCorrente}</small>
        )}
      </div>
      <div className="col-md-4">
        <label htmlFor="dataAdmissaoExam" className="form-label">
          Data do Exame Admissional <span className="text-danger">*</span>
        </label>
        <InputDate
          id="dataAdmissaoExam"
          name="dataAdmissaoExam"
          value={dados.dataAdmissaoExam}
          onChange={(dateString) => {
            setDados((prev) => ({ ...prev, dataAdmissaoExam: dateString }));
            handleFieldChange('dataAdmissaoExam', dateString);
          }}
          placeholder="dd/mm/aaaa"
          className={`w-100 ${errors.dataAdmissaoExam ? 'p-invalid' : ''}`}
        />
        {errors.dataAdmissaoExam && (
          <small className="text-danger">{errors.dataAdmissaoExam}</small>
        )}
      </div>
      <div className="col-md-4">
        <label htmlFor="tamanhoUniforme" className="form-label">
          Tamanho do Uniforme <span className="text-danger">*</span>
        </label>
        <Dropdown
          id="tamanhoUniforme"
          name="tamanhoUniforme"
          value={dados.tamanhoUniforme}
          onChange={(e) => {
            setDados({ ...dados, tamanhoUniforme: e.value });
            handleFieldChange('tamanhoUniforme', e.value);
          }}
          options={["P", "M", "G", "GG", "EG"]}
          placeholder="Selecione o tamanho"
          className={`w-100 ${errors.tamanhoUniforme ? 'p-invalid' : ''}`}
        />
        {errors.tamanhoUniforme && (
          <small className="text-danger">{errors.tamanhoUniforme}</small>
        )}
      </div>
      <div className="col-md-4">
        <label htmlFor="salario" className="form-label">
          Salário <span className="text-danger">*</span>
        </label>
        <InputText
          id="salario"
          name="salario"
          value={dados.salario}
          onChange={(e) => {
            const formattedValue = MaskUtil.formatarMoeda(e.target.value);
            setDados({
              ...dados,
              salario: formattedValue
            });
            handleFieldChange('salario', formattedValue);
          }}
          onKeyPress={(e) => {
            if (!/[0-9]/.test(e.key)) {
              e.preventDefault();
            }
          }}
          className={`form-control ${errors.salario ? 'p-invalid' : ''}`}
        />
        {errors.salario && (
          <small className="text-danger">{errors.salario}</small>
        )}
      </div>
      <div className="col-md-4">
        <label htmlFor="horarioTrabalho" className="form-label">
          Horário de Trabalho
        </label>
        <Dropdown
          id="horarioTrabalho"
          name="horarioTrabalho"
          value={dados.horarioTrabalho}
          onChange={(e) => HandleChange({ target: { name: "horarioTrabalho", value: e.value } })}
          options={LISTA_HORARIOS}
          placeholder="Selecione o horário"
          className="w-100"
        />
      </div>
      <div className="col-md-4">
        <label htmlFor="regimeContratacaoId" className="form-label">
          Regime de Contratação <span className="text-danger">*</span>
        </label>
        <Dropdown
          id="regimeContratacaoId"
          value={dados.regimeContratacaoId}
          onChange={(e) => {
            HandleDropdownChange(e, "regimeContratacaoId");
            handleFieldChange('regimeContratacaoId', e.value);
          }}
          options={regimes}
          placeholder="Selecione o Regime de Contratação"
          className={`w-100 ${errors.regimeContratacaoId ? 'p-invalid' : ''}`}
        />
        {errors.regimeContratacaoId && (
          <small className="text-danger">{errors.regimeContratacaoId}</small>
        )}
      </div>
      <div className="col-md-4">
        <label htmlFor="jornadaTrabalhoId" className="form-label">
          Jornada de Trabalho <span className="text-danger">*</span>
        </label>
        <Dropdown
          id="jornadaTrabalhoId"
          value={dados.jornadaTrabalhoId}
          onChange={(e) => {
            HandleDropdownChange(e, "jornadaTrabalhoId");
            handleFieldChange('jornadaTrabalhoId', e.value);
          }}
          options={jornadas}
          placeholder="Selecione a Jornada de Trabalho"
          className={`w-100 ${errors.jornadaTrabalhoId ? 'p-invalid' : ''}`}
        />
        {errors.jornadaTrabalhoId && (
          <small className="text-danger">{errors.jornadaTrabalhoId}</small>
        )}
      </div>
      
      <div className="col-md-4">
        <label htmlFor="tipoEscala" className="form-label">
          Tipo Escala <span className="text-danger">*</span>
        </label>
        <Dropdown
          id="tipoEscala"
          value={dados.tipoEscala}
          onChange={(e) => {
            HandleDropdownChange(e, "tipoEscala");
            handleFieldChange('tipoEscala', e.value);
          }}
          options={TipoEscala}
          placeholder="Selecione a escala"
          className={`w-100 ${errors.tipoEscala ? 'p-invalid' : ''}`}
        />
        {errors.tipoEscala && (
          <small className="text-danger">{errors.tipoEscala}</small>
        )}
      </div>

      {/* Seção PCD */}
      <div className="col-12">
        <hr className="my-4" />
        <h5 className="mb-3">Informações sobre PCD (Pessoa com Deficiência)</h5>
        
        {/* Mensagem Legal */}
        <div className="alert alert-info mb-4">
          <div className="d-flex align-items-start">
            <i className="pi pi-info-circle me-3 mt-1" style={{ fontSize: '1.2rem' }} />
            <div>
                             <h6 className="mb-2">Informação Legal sobre PCD</h6>
               <p className="mb-0 small">
                <strong>Importante:</strong> A declaração de PCD deve ser acompanhada de laudo médico que comprove a deficiência 
                e sua compatibilidade com a função a ser exercida, conforme estabelecido pelo Decreto nº 5.296/2004.
              </p>
            </div>
          </div>
        </div>

                 {/* Campo PCD */}
         <div className="row g-3">
           <div className="col-md-6">
             <label htmlFor="isPcd" className="form-label">
               É Pessoa com Deficiência (PCD)?
             </label>
             <div className="d-flex align-items-center">
               <InputSwitch
                 id="isPcd"
                 checked={dados.isPcd || false}
                 onChange={(e) => handlePcdChange(e.value)}
                 className="me-3"
               />
               <span className="text-muted">
                 {dados.isPcd ? "Sim" : "Não"}
               </span>
             </div>
           </div>

           {/* Campo PCD - aparece apenas quando é PCD */}
           {dados.isPcd && (
             <div className="col-md-6">
               <label htmlFor="pcdId" className="form-label">
                 Tipo de Deficiência <span className="text-danger">*</span>
               </label>
               <Dropdown
                 id="pcdId"
                 value={dados.pcdId}
                 onChange={(e) => {
                   HandleDropdownChange(e, "pcdId");
                   handleFieldChange('pcdId', e.value);
                 }}
                 options={pcds}
                 placeholder="Selecione o tipo de deficiência"
                 className={`w-100 ${errors.pcdId ? 'p-invalid' : ''}`}
               />
               {errors.pcdId && (
                 <small className="text-danger">{errors.pcdId}</small>
               )}
             </div>
           )}

                     {/* Campos condicionais para PCD */}
           {dados.isPcd && (
             <div className="col-md-12">
                <label htmlFor="laudoPcd" className="form-label">
                  Laudo Médico (apenas PDF) <span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  id="laudoPcd"
                  name="laudoPcd"
                  accept=".pdf"
                  className={`form-control ${errors.laudoPcd ? 'is-invalid' : ''}`}
                  onChange={handleLaudoChange}
                />
                {errors.laudoPcd && (
                  <small className="text-danger">{errors.laudoPcd}</small>
                )}
                <small className="text-muted">
                  O laudo deve ser legível e estar dentro da validade.
                </small>
                
                                 {laudoPcd && (
                   <div className="mt-3">
                     <small className="text-muted">
                       Arquivo selecionado: {laudoPcd.name}
                     </small>
                   </div>
                 )}

                {/* Informações do laudo existente */}
                {dados.urlLaudoMedico && dados.nomeArquivoLaudoMedico && (
                  <div className="mt-3 p-3 border rounded bg-light">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="mb-1">Laudo Médico Existente</h6>
                        <p className="mb-0 text-muted small">
                          <i className="pi pi-file-pdf me-2" />
                          {dados.nomeArquivoLaudoMedico}
                        </p>
                      </div>
                      <div className="d-flex gap-2">
                        <Button
                          type="button"
                          label="Download"
                          icon="pi pi-download"
                          className="btn btn-outline-primary btn-sm"
                          onClick={handleDownloadLaudo}
                        />
                        <Button
                          type="button"
                          label="Remover"
                          icon="pi pi-trash"
                          className="btn btn-outline-danger btn-sm"
                          onClick={handleRemoveLaudo}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
          )}
        </div>
      </div>

      <div className="col-12">
        <CustomBoxBtns />
      </div>
    </div>
  );
};

DadosAdmissionais.propTypes = {
  dados: PropTypes.shape({
    funcaoId: PropTypes.string,
    cargo: PropTypes.string,
    departamentoId: PropTypes.string,
    escolaridadeId: PropTypes.string,
    dataAdmissao: PropTypes.string,
    banco: PropTypes.string,
    agencia: PropTypes.string,
    contaCorrente: PropTypes.string,
    dataAdmissaoExam: PropTypes.string,
    tamanhoUniforme: PropTypes.oneOf(["P", "M", "G", "GG", "EG"]),
    salario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    horarioTrabalho: PropTypes.string,
    regimeContratacaoId: PropTypes.string,
    jornadaTrabalhoId: PropTypes.string,
    pcdId: PropTypes.string,
            tipoEscala: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        isPcd: PropTypes.bool,
        laudoPcd: PropTypes.oneOfType([PropTypes.object, PropTypes.instanceOf(File)]),
        urlLaudoMedico: PropTypes.string,
        nomeArquivoLaudoMedico: PropTypes.string
  }).isRequired,
  setDados: PropTypes.func.isRequired,
  funcoes: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ).isRequired,
  HandleDropdownChange: PropTypes.func.isRequired,
  HandleChange: PropTypes.func.isRequired,
  departamentos: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ).isRequired,
  escolaridades: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ).isRequired,
  regimes: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ).isRequired,
  jornadas: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ).isRequired,
  pcds: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ).isRequired,
  BoxBtns: PropTypes.func.isRequired,
  isNewFuncionario: PropTypes.bool,
  funcionarioId: PropTypes.string,
  onNextTab: PropTypes.func,
  onPreviousTab: PropTypes.func,
  onSave: PropTypes.func,
  onLaudoPcdChange: PropTypes.func
};

DadosAdmissionais.defaultProps = {
  isNewFuncionario: false,
  funcionarioId: "",
  onNextTab: () => {},
  onPreviousTab: () => {},
  onSave: () => {},
  onLaudoPcdChange: () => {}
};

export default DadosAdmissionais;
